/**
 * Security fallback for legacy Lottie topic icons.
 *
 * lottie-web evaluates expressions contained in animation JSON. Remote or
 * user-provided animations are therefore not loaded or executed. Existing
 * legacy values degrade to their emoji fallback.
 */

export function LottieFromUrl({ url, size, fallback }: {
  url: string; size: number; fallback?: string;
}) {
  void url;
  return <span style={{ fontSize: size * 0.85, lineHeight: 1, opacity: 0.6 }}>{fallback || "🎬"}</span>;
}
